export const baseURL = '//cc.video.qq.com'
